import React, { Component, useState } from "react"
import { withRouter, RouteComponentProps } from "react-router-dom"
import { CDN_PUB_URL_BELLRINGERS } from "../../constants"
import Button from "../../components/Button/Button"
import Calculator, { CalculatorConfig } from "../../components/Calculator"
import { capitilizeFirstLetter } from "../../services/utils/text-util"
import { getBellringerSetNumber, getBellringersTestQuestions, getBellringerTestMetaData, IBellringersTestQuestion, WEEKLY_QUESTIONS_PER_SUBJECT } from "../../services/bellringers"
import BellringersQuestionView from "./BellringersQuestionView"
import { MainReviewPage, MiniReview } from "./ReviewPages"
import { SimpleTimer } from "../../services/utils/simple-timer"
import { Context, Resource, sendUserActivity, UserActivityEx } from "../../services/liveview/liveview-service"

interface Props {
    userInfo: any
    bellringersTestId: string
}

interface State {
    questions: IBellringersTestQuestion[]
    currentQuestionIndex: number
    showModal: boolean
    miniReviewPageVisible: boolean
    mainReviewPageVisible: boolean
    calculatorVisibleACT: boolean
    calculatorVisibleSAT: boolean
    disablePrev: boolean
    disableNext: boolean
    showFinishButton: boolean
}

type AllProps = Props & RouteComponentProps<any>

export class BellringersWeeklyTest extends Component<AllProps, State> {
    simpleTimer = new SimpleTimer()

    constructor(props) {
        super(props)
        this.state = {
            questions: [],
            currentQuestionIndex: 0,
            showModal: false,
            miniReviewPageVisible: false,
            mainReviewPageVisible: false,
            calculatorVisibleACT: false, // ACT calc
            calculatorVisibleSAT: false, // SAT calc
            disablePrev: true,
            disableNext: false,
            showFinishButton: false,
        }
    }

    componentDidMount(): void {
        this.initialize()
    }

    initialize = async () => {
        let {bellringersTestId} = this.props
        let questions = await getBellringersTestQuestions(bellringersTestId)
        this.setState({questions})
    }

    componentWillUnmount(): void {
        this.sendStats()
    }

    sendStats() {
        let {bellringersTestId} = this.props
        let {subject} = getBellringerTestMetaData(bellringersTestId)
        let seconds = this.simpleTimer.diffInSeconds()
        let ended = seconds
        let context = Context.BELLRINGER
        let contextId = "BellringersWeeklyTest"
        let category = subject
        let resource = Resource.TEST_SESSION
        let resourceId = bellringersTestId
        let userActivityEx: UserActivityEx = {
            context, contextId, 
            resource, resourceId, 
            category,
            ended
        }
        sendUserActivity(userActivityEx, true)
        this.simpleTimer.reset()
    }

    handlePrev = () => {
        let {currentQuestionIndex, disablePrev, mainReviewPageVisible} = this.state

        if (!mainReviewPageVisible) {
            currentQuestionIndex--
        }

        currentQuestionIndex = currentQuestionIndex <= 0 ? 0: currentQuestionIndex
        disablePrev = currentQuestionIndex === 0 ? true: false
        this.setState({currentQuestionIndex, disablePrev, disableNext: false, mainReviewPageVisible: false, showFinishButton: false})
    }

    handleNext = () => {
        let {currentQuestionIndex, disableNext, mainReviewPageVisible} = this.state
        let maxIndex = WEEKLY_QUESTIONS_PER_SUBJECT - 1
        currentQuestionIndex++

        if (mainReviewPageVisible) {
            this.handleClose()
            return
        }

        if (currentQuestionIndex === maxIndex+1) {
            this.setState({mainReviewPageVisible: true, showFinishButton: true})
            return
        }

        currentQuestionIndex = currentQuestionIndex >= maxIndex ? maxIndex: currentQuestionIndex
        disableNext = currentQuestionIndex === (maxIndex + 1) ? true: false
        this.setState({currentQuestionIndex, disablePrev: false, disableNext, mainReviewPageVisible: false})
    }

    handleClose = () => {
        let belllrignersHomeLink = `/app/bellringers`
        this.props.history.goBack()
    }

    handleAnswer = (question, userAnswer) => {
        // console.log("OT: Will handleAnswer!", question, userAnswer)
    }

    toggleMiniReview = () => {
        let {miniReviewPageVisible} = this.state
        this.setState({miniReviewPageVisible: !miniReviewPageVisible})
    }

    showMainReviewPage = () => {
        this.setState({mainReviewPageVisible: true, miniReviewPageVisible: false})
    }

    closeMiniReview = () => {
        this.setState({miniReviewPageVisible: false})
    }

    gotoQuestion = (questionNumber: number) => {
        let questionIndex = questionNumber - 1 // 0-based index
        let disablePrev = questionIndex <= 0
        this.setState({
            currentQuestionIndex: questionIndex, 
            miniReviewPageVisible: false, 
            mainReviewPageVisible: false, 
            disablePrev,
        })
    }

    handleTestExit = () => {
        this.handleClose()
    }

    closeCalculatorACT = () => {
        this.setState({calculatorVisibleACT: false})
    }

    closeCalculatorSAT = () => {
        this.setState({calculatorVisibleSAT: false})
    }


    toggleCalculatorACT = () => {
        let {calculatorVisibleACT} = this.state
        console.log("OT: toggleCalculatorACT", calculatorVisibleACT)
        this.setState({calculatorVisibleACT: !calculatorVisibleACT, calculatorVisibleSAT: false})
    }

    toggleCalculatorSAT = () => {
        let {calculatorVisibleSAT} = this.state
        console.log("OT: toggleCalculatorSAT", calculatorVisibleSAT)
        this.setState({calculatorVisibleSAT: !calculatorVisibleSAT, calculatorVisibleACT: false})
    }

    render() {
        let {bellringersTestId, userInfo} = this.props
        let {questions, currentQuestionIndex, disablePrev, disableNext, showFinishButton, miniReviewPageVisible, mainReviewPageVisible, calculatorVisibleACT, calculatorVisibleSAT } = this.state
        let question = questions[currentQuestionIndex] as IBellringersTestQuestion

        if (!question) return "No Bellringers question found!"

        let {subject, grade, week} = getBellringerTestMetaData(bellringersTestId)
        let subjectInfo = capitilizeFirstLetter(subject)
        let setNumber = getBellringerSetNumber(grade)
        let sectionTitle = `${subjectInfo} Set: ${setNumber} Week: ${week}`
        let miniReviewTitle = `${sectionTitle} Questions`
        let calculatorConfig: CalculatorConfig = "ACT"
        let calculatorClassACT = calculatorVisibleACT ? "" : "hide"
        let calculatorClassSAT = calculatorVisibleSAT ? "" : "hide"
        let calculatorAllowed = true

        return (
            <div className="bellringers-weekly-test-container">
                <BellringersTestQuestionView
                    questions={questions}
                    question={question}
                    currentQuestionIndex={currentQuestionIndex}
                    userInfo={userInfo}
                    subject={subject}
                    grade={grade}
                    week={week}
                    sectionTitle={sectionTitle}
                    disablePrev={disablePrev}
                    disableNext={disableNext}
                    showFinishButton={showFinishButton}
                    miniReviewPageVisible={miniReviewPageVisible}
                    mainReviewPageVisible={mainReviewPageVisible}
                    onPrev={this.handlePrev}
                    onNext={this.handleNext}
                    onClose={this.handleClose}
                    onToggleMiniReview={this.toggleMiniReview}
                    onAnswer={this.handleAnswer}
                    onGotoQuestion={this.gotoQuestion}
                    onTestExit={this.handleTestExit}
                    onToggleCalculatorACT={this.toggleCalculatorACT}
                    onToggleCalculatorSAT={this.toggleCalculatorSAT}
                />

                { miniReviewPageVisible && 
                    <MiniReview 
                        title={miniReviewTitle} 
                        questions={questions}
                        currentQuestionIndex={currentQuestionIndex}
                        onClose={this.closeMiniReview}
                        onGotoQuestion={this.gotoQuestion}
                        onGotoReviewPage={this.showMainReviewPage}
                    />
                }
                { calculatorAllowed && calculatorVisibleACT &&
                    <Calculator 
                        title="ACT Calculator"
                        config={"ACT"} 
                        draggable={true} 
                        onClose={this.closeCalculatorACT} 
                        calculatorClass={calculatorClassACT} />
                }
                { calculatorAllowed && calculatorVisibleSAT &&
                    <Calculator
                        title="SAT Calculator"
                        config={"SAT"} 
                        draggable={true} 
                        onClose={this.closeCalculatorSAT} 
                        calculatorClass={calculatorClassSAT} />
                }
            </div>
        )
    }
}


interface IBellringersTestQuestionViewProps {
    questions: IBellringersTestQuestion[]
    question: IBellringersTestQuestion
    currentQuestionIndex: number
    userInfo: {firstName: string, lastName: string}
    subject: string 
    grade: number 
    week: number
    sectionTitle: string
    disablePrev: boolean
    disableNext: boolean
    miniReviewPageVisible: boolean
    mainReviewPageVisible: boolean
    showFinishButton: boolean
    onPrev: () => void
    onNext: () => void
    onClose: () => void
    onToggleMiniReview: () => void
    onAnswer: (question, userAnswer: string) => void
    onGotoQuestion: (questionNumber:number) => void
    onTestExit: () => void
    onToggleCalculatorACT: () => void
    onToggleCalculatorSAT: () => void
}

function BellringersTestQuestionView(props: IBellringersTestQuestionViewProps) {
    let {questions, question, sectionTitle, currentQuestionIndex, userInfo, subject, grade, week, mainReviewPageVisible, disablePrev, disableNext, showFinishButton, onPrev, onNext, onToggleMiniReview, onGotoQuestion, onTestExit, onToggleCalculatorACT, onToggleCalculatorSAT,} = props

    if (!question) return null

    let questionNumber = currentQuestionIndex + 1
    let {firstName, lastName} = userInfo
    let {optionA, optionB, optionC, optionD} = question

    function prepareChoice(choice: string) {
        if (!choice) return ""
        if (choice.includes("$CDN")) {
            let url = choice.replace("$CDN", CDN_PUB_URL_BELLRINGERS)
            return `<img src=${url} class="question-option" alt="option"/>`
        }
        return choice
    }

    let options = [
        { value: "A", label: prepareChoice(optionA), },
        { value: "B", label: prepareChoice(optionB), },
        { value: "C", label: prepareChoice(optionC), },
        { value: "D", label: prepareChoice(optionD), },
    ]

    function handleHighlight() {
        console.log("OT: handleHighlight")
    }

    let subjectInfo = capitilizeFirstLetter(subject)
    let testInfo = "Bellringers Weekly Test"
    let mainReviewTitle = `Check Your Work`
    let mainReviewSectionTitle = `${sectionTitle} Questions`

    return (
        <div className="bellringers-test-question">
            <div className="section-top">
                <SectionTop
                    subject={subject}
                    sectionTitle={sectionTitle}
                    testInfo={testInfo}
                    onToggleCalculatorACT={onToggleCalculatorACT}
                    onToggleCalculatorSAT={onToggleCalculatorSAT}
                    onToggleHighlight={handleHighlight}
                    onTestExit={onTestExit}
                />
            </div>

            <div className="section-middle">
                {!mainReviewPageVisible ?
                    <BellringersQuestionView question={question}/>
                    :
                    <MainReviewPage
                        mainTitle={mainReviewTitle}
                        title={mainReviewSectionTitle}
                        questions={questions}
                        onGotoQuestion={onGotoQuestion}
                    />
                }
            </div>

            <SectionBottom 
                firstName={firstName} 
                lastName={lastName} 
                questionNumber={questionNumber}
                questionMax={WEEKLY_QUESTIONS_PER_SUBJECT}
                onPrev={onPrev}
                onNext={onNext}
                onToggleMiniReview={onToggleMiniReview}
                disablePrev={disablePrev}
                disableNext={disableNext}
                showFinishButton={showFinishButton}
            />
        </div>
    )
}


function SectionTop(props) {
    let {subject, sectionTitle, testInfo, onToggleCalculatorACT, onToggleCalculatorSAT, onToggleLineReader, onToggleHighlight, onTestExit} = props
    let allowCalculator = subject === "math"
    let allowHighlight = false // subject !== "math"

    return (
        <>
            <div className="section-top">
                <div className="section-info align-items-end">
                        <div className="section-info-item w-100 w-md-auto">
                            <h5 className="section-info-title mb-0">{sectionTitle}</h5>
                        </div>
                        <div className="section-info-item d-flex justify-content-end">
                            { allowCalculator &&
                                <div>
                                    <button title="ACT Calculator" className="btn-simple mr-3" onClick={onToggleCalculatorACT}>
                                        <img
                                            alt="ACT Calculator"
                                            width="16"
                                            height="20"
                                            src="/assets/images/icons/v2/ico-calculator.svg" />
                                        <br/>
                                        <span className="d-none d-md-block">ACT</span>
                                    </button>
                                    <button title="SAT Calculator" className="btn-simple mr-3" onClick={onToggleCalculatorSAT}>
                                        <img
                                            alt="SAT Calculator"
                                            width="16"
                                            height="20"
                                            src="/assets/images/icons/v2/ico-calculator.svg" />
                                        <br/>
                                        <span className="d-none d-md-block">SAT</span>
                                    </button>
                                </div>
                            }
                            { allowHighlight &&
                                <div id="highlights-and-notes">
                                    <button title="Highlights" className="btn-simple mr-3" onMouseOver={e => onToggleHighlight(true)} onMouseLeave={e => onToggleHighlight(false)}>
                                        <img
                                            alt="Highlights"
                                            width="16"
                                            height="20"
                                            src="/assets/images/icons/v2/ico-highlighter.svg" />
                                        <br/>
                                        <span className="d-none d-md-block">Highlights</span>
                                    </button>
                                </div>
                            }

                            <div className="menu-dropdown-item">
                                <button title="More" className="btn-simple">
                                    <img
                                        alt="More"
                                        width="20"
                                        height="20"
                                        src="/assets/images/icons/v2/ico-more-vertical.svg" />
                                    <br/>
                                    <span className="d-none d-md-block">More</span>
                                    <div className="more-menu-dropdown">
                                        {/* <div className="mb-3">
                                            <button title="Line Reader" className="btn-simple" onClick={onToggleLineReader}>
                                                <img
                                                alt="Line Reader"
                                                className="mr-2 smallIcon"
                                                width="14"
                                                height="20"
                                                src="/assets/images/icons/v2/ico-line-reader-outline.svg" />
                                                <span>Line Reader</span>
                                            </button>
                                        </div> */}
                                        <div>
                                            <button title="Save &amp; Exit" className="btn-simple" onClick={onTestExit}>
                                            <img
                                                alt="Save &amp; Exit"
                                                className="mr-2"
                                                width="16"
                                                height="20"
                                                src="/assets/images/icons/v2/ico-save-exit-outline.svg" />
                                                <span>Save &amp; Exit</span>
                                            </button>
                                        </div>
                                    </div>
                                </button>
                            </div>
                        </div>
                </div>
            </div>
            <div className="section-subinfo ">
                <div className="test-info">
                    {testInfo}
                </div>
            </div>
        </>
    )
}

function SectionBottom(props) {
    let {firstName, lastName, questionNumber, questionMax, onPrev, onNext, onToggleMiniReview, disablePrev, disableNext, showFinishButton } = props
    let userName = `${firstName} ${lastName}`
    let [isOpen, setIsOpen] = useState(false)
    let handleToggle = () => {
        setIsOpen(val => !val)
        onToggleMiniReview && onToggleMiniReview()
    }

    return (
        <div className="section-bottom ">
            <div className="bottom-left">
                {userName}
            </div>
            <div className="bottom-middle">
                <button className={`btn btn--bg-black btn--text-white btn-toggle-end` + (isOpen ? " is-open" : "")} onClick={handleToggle}>
                    Question {questionNumber} of {questionMax} <span className="collapsable-card__collapse-btn"></span>
                </button>
            </div>
             <div className="bottom-right">
                {!disablePrev && <Button text={"Back"} onClick={onPrev} disabled={disablePrev}/>}
                {!showFinishButton ?
                    <Button text={"Next"} onClick={onNext} disabled={disableNext}/>
                    :
                    <Button text={"Finish"} onClick={onNext}/>
                }
            </div>
        </div>
    )
}


const ConnectedBellringersWeeklyTest = withRouter(BellringersWeeklyTest)

export default (props) => {
    return (
        <ConnectedBellringersWeeklyTest {...props} />
    )
}

